// extracted by mini-css-extract-plugin
export default {"container":"POIListView_container__jykqf","selected":"POIListView_selected__hZ4mK","scroll":"POIListView_scroll__Yc957"};